import React from 'react';

import * as S from './styles';

export default function Footer() {
  return <S.Container />;
}
